import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function MenuBar({ setShowStats, setShowAbout }) {
	const classes = useStyles();

	const showStatHandler = () => {
		setShowStats(true);
	};

	const showAboutHandler = () => {
		setShowAbout(true);
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar position="static">
				<Toolbar variant="dense">
					<Typography variant="h6" className={classes.title}>
						{"Cessnock.Life"}
					</Typography>
					<Button
						color="inherit"
						onClick={() => {
							showStatHandler();
						}}
					>
						<span role="img" aria-label="chart emoji">
							📊
						</span>
						Stats
					</Button>
					<Button
						color="inherit"
						size="small"
						onClick={() => {
							showAboutHandler();
						}}
					>
						<HelpOutlineIcon />
					</Button>
				</Toolbar>
			</AppBar>
		</div>
	);
}
